// @flow
import React from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Modal } from '@shopify/polaris';

interface ComposedPropsItem extends WithI18nProps {
  onClose: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  isLoadingDisconnect: boolean;
}

const ConfirmDisconnectModal: React.FC<ComposedPropsItem> = ({
  onClose,
  onConfirm,
  isOpen,
  isLoadingDisconnect,
  i18n
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={i18n.translate('AdminHTML.GoogleAnalytics4.DisconnectModal.title')}
      primaryAction={[
        {
          content: i18n.translate('AdminHTML.GoogleAnalytics4.DisconnectModal.remove'),
          onAction: onConfirm,
          loading: isLoadingDisconnect,
          destructive: true
        }
      ]}
      secondaryActions={[
        {
          content: i18n.translate('AdminHTML.GoogleAnalytics4.DisconnectModal.cancel'),
          onAction: onClose
        }
      ]}>
      <p style={{ padding: '24px 20px' }}>
        {i18n.translate('AdminHTML.GoogleAnalytics4.DisconnectModal.description', {
          t1: (
            <strong>
              {i18n.translate('AdminHTML.GoogleAnalytics4.DisconnectModal.stDescriptionBold')}
            </strong>
          ),
          t2: (
            <strong>
              {i18n.translate('AdminHTML.GoogleAnalytics4.DisconnectModal.ndDescriptionBold')}
            </strong>
          ),
          t3: (
            <strong>
              {i18n.translate('AdminHTML.GoogleAnalytics4.DisconnectModal.rdDescriptionBold')}
            </strong>
          ),
          t4: (
            <strong>
              {i18n.translate('AdminHTML.GoogleAnalytics4.DisconnectModal.thDescriptionBold')}
            </strong>
          )
        })}
      </p>
    </Modal>
  );
};

export default withI18n()(ConfirmDisconnectModal);
